import React, { useEffect, useState } from 'react';
import Image from '../Image';
import Button from '../Button';
import { useModal } from '../../context/ModalContext';

import { Link, useNavigate } from 'react-router-dom';
import { rewriteAdultCollectionUrl } from '../../utils/anamneseVersion';

import battery from '../../assets/images/svg/battery.svg';
import rocketIcon from '../../assets/images/svg/rocketIcon.svg';
import brainIcon from '../../assets/images/svg/brainIcon.svg';
import plantIcon from '../../assets/images/svg/plantIcon.svg';
import shieldCheckIcon from '../../assets/images/svg/shieldCheckIcon.svg';
import upgradeIcon from '../../assets/images/svg/upgradeIcon.svg';
import helpWhiteIcon from '../../assets/images/svg/helpWhiteIcon.svg';
import downloadWhiteIcon from '../../assets/images/svg/downloadWhiteIcon.svg';
import percentIcon from '../../assets/images/svg/percentIcon.svg';

const ModalSliderKitDetails = () => {
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const handleNavigate = (url) => {
    closeModal();
    navigate(rewriteAdultCollectionUrl(url));
  };

  const kits = [
    {
      version: 'ESSENCIAL',
      image: 'unboxing-basic.png',
      subtitle: 'A Fórmula Suprema para Longevidade e Alta Performance',
      price: '497.00',
      level: 'O mais completo, para quem quer o máximo.',
      details: `
              <div class="row">
                <div class="col-md-6">
                  <h4><img src=${rocketIcon} alt="rocketIcon" />TUDO DO ESSENCIAL <br>+ PREMIUM, MAIS:</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Peptídeos Bioativos de Colágeno (Fortigel)</p>
                        <p>Combinação superior para articulações, pele, cabelo e unhas</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Ácido R-Lipoico + PQQ</p>
                        <p>Regeneração mitocondrial e produção de energia celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">NADH + NMN</p>
                        <p>Ativação de vias da longevidade e reparação celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Carnosina</p>
                        <p>Proteção contra glicação e envelhecimento celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Coenzima Q10 Microencapsulada (Kaneka Ubiquinol)</p>
                        <p>Máxima absorção e eficiência energética</p>
                    </li>
                  </ul>
  
                  <h4><img src=${brainIcon} alt="brainIcon" />CÉREBRO <br>E PERFORMANCE COGNITIVA:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Lion’s Mane + Rhodiola Rosea</p>
                        <p>Suporte para memória, concentração e resiliência mental</p>
                    </li>
                  </ul>
  
                  <h4><img src=${shieldCheckIcon} alt="shieldCheckIcon" />SISTEMA IMUNOLÓGICO <br>E DEFESA CELULAR:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Beta-Glucanas + Arabinogalactana</p>
                        <p>Reforço imunológico de elite</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Lactoferrina</p>
                        <p>Modulação imunológica e absorção eficiente de ferro</p>
                    </li>
                  </ul>
                </div>
  
                <div class="col-md-6">
                  <h4><img src=${plantIcon} alt="plantIcon" />EXTRATOS BOTÂNICOS <br>POTENTES</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        Complexo Adaptógeno (Ginseng)
                        Equilíbrio hormonal e suporte ao estresse
                    </li>
                    <li class="check-icon">
                        Extrato de Romã + Polifenóis de Uva
                    </li>
                    <li class="check-icon">
                        Curcumina com tecnologia NovaSol
                    </li>
                    <li class="check-icon">
                        Spermidina + Apigenina
                    </li>
                    <li class="check-icon">
                        Extrato de Chá Verde + EGCG
                    </li>
                    <li class="check-icon">Fisetina + Pterostilbeno
                    </li>
                  </ul>
  
                  <h4><img src=${upgradeIcon} alt="upgradeIcon" />UPGRADES:</h4>
                  <hr/>
                  <ul class="list-unstyled upgrades">
                    <li class="check-icon">Ativação celular para longevidade e regeneração</li>
                    <li class="check-icon">Otimização máxima para sistema nervoso, imunológico e cardiovascular</li>
                    <li class="check-icon">Suporte avançado para mitocôndrias e metabolismo energético</li>
                    <li class="check-icon">Antienvelhecimento e autofagia celular aprimorada</li>
                  </ul>
                </div>
              </div>`
    },
    {
      version: 'PREMIUM',
      image: 'unboxing-premium.png',
      subtitle: 'A Fórmula Suprema para Longevidade e Alta Performance',
      price: '697.00',
      level: 'O mais completo, para quem quer o máximo.',
      details: `
              <div class="row">
                <div class="col-md-6">
                  <h4><img src=${rocketIcon} alt="rocketIcon" />TUDO DO ESSENCIAL <br>+ PREMIUM, MAIS:</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Peptídeos Bioativos de Colágeno (Fortigel)</p>
                        <p>Combinação superior para articulações, pele, cabelo e unhas</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Ácido R-Lipoico + PQQ</p>
                        <p>Regeneração mitocondrial e produção de energia celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">NADH + NMN</p>
                        <p>Ativação de vias da longevidade e reparação celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Carnosina</p>
                        <p>Proteção contra glicação e envelhecimento celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Coenzima Q10 Microencapsulada (Kaneka Ubiquinol)</p>
                        <p>Máxima absorção e eficiência energética</p>
                    </li>
                  </ul>
  
                  <h4><img src=${brainIcon} alt="brainIcon" />CÉREBRO <br>E PERFORMANCE COGNITIVA:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Lion’s Mane + Rhodiola Rosea</p>
                        <p>Suporte para memória, concentração e resiliência mental</p>
                    </li>
                  </ul>
  
                  <h4><img src=${shieldCheckIcon} alt="shieldCheckIcon" />SISTEMA IMUNOLÓGICO <br>E DEFESA CELULAR:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Beta-Glucanas + Arabinogalactana</p>
                        <p>Reforço imunológico de elite</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Lactoferrina</p>
                        <p>Modulação imunológica e absorção eficiente de ferro</p>
                    </li>
                  </ul>
                </div>
  
                <div class="col-md-6">
                  <h4><img src=${plantIcon} alt="plantIcon" />EXTRATOS BOTÂNICOS <br>POTENTES</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        Complexo Adaptógeno (Ginseng)
                        Equilíbrio hormonal e suporte ao estresse
                    </li>
                    <li class="check-icon">
                        Extrato de Romã + Polifenóis de Uva
                    </li>
                    <li class="check-icon">
                        Curcumina com tecnologia NovaSol
                    </li>
                    <li class="check-icon">
                        Spermidina + Apigenina
                    </li>
                    <li class="check-icon">
                        Extrato de Chá Verde + EGCG
                    </li>
                    <li class="check-icon">Fisetina + Pterostilbeno
                    </li>
                  </ul>
  
                  <h4><img src=${upgradeIcon} alt="upgradeIcon" />UPGRADES:</h4>
                  <hr/>
                  <ul class="list-unstyled upgrades">
                    <li class="check-icon">Ativação celular para longevidade e regeneração</li>
                    <li class="check-icon">Otimização máxima para sistema nervoso, imunológico e cardiovascular</li>
                    <li class="check-icon">Suporte avançado para mitocôndrias e metabolismo energético</li>
                    <li class="check-icon">Antienvelhecimento e autofagia celular aprimorada</li>
                  </ul>
                </div>
              </div>`
    },
    {
      version: 'PLATINUM',
      image: 'unboxing-platinum.png',
      subtitle: 'A Fórmula Suprema para Longevidade e Alta Performance',
      price: '1997.00',
      level: 'O mais completo, para quem quer o máximo.',
      details: `
              <div class="row">
                <div class="col-md-6">
                  <h4><img src=${rocketIcon} alt="rocketIcon" />TUDO DO ESSENCIAL <br>+ PREMIUM, MAIS:</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Peptídeos Bioativos de Colágeno (Fortigel)</p>
                        <p>Combinação superior para articulações, pele, cabelo e unhas</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Ácido R-Lipoico + PQQ</p>
                        <p>Regeneração mitocondrial e produção de energia celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">NADH + NMN</p>
                        <p>Ativação de vias da longevidade e reparação celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Carnosina</p>
                        <p>Proteção contra glicação e envelhecimento celular</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Coenzima Q10 Microencapsulada (Kaneka Ubiquinol)</p>
                        <p>Máxima absorção e eficiência energética</p>
                    </li>
                  </ul>
  
                  <h4><img src=${brainIcon} alt="brainIcon" />CÉREBRO <br>E PERFORMANCE COGNITIVA:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Lion’s Mane + Rhodiola Rosea</p>
                        <p>Suporte para memória, concentração e resiliência mental</p>
                    </li>
                  </ul>
  
                  <h4><img src=${shieldCheckIcon} alt="shieldCheckIcon" />SISTEMA IMUNOLÓGICO <br>E DEFESA CELULAR:</h4>
                  <hr />
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        <p class="title">Beta-Glucanas + Arabinogalactana</p>
                        <p>Reforço imunológico de elite</p>
                    </li>
                    <li class="check-icon">
                        <p class="title">Lactoferrina</p>
                        <p>Modulação imunológica e absorção eficiente de ferro</p>
                    </li>
                  </ul>
                </div>
  
                <div class="col-md-6">
                  <h4><img src=${plantIcon} alt="plantIcon" />EXTRATOS BOTÂNICOS <br>POTENTES</h4>
                  <hr/>
                  <ul class="list-unstyled">
                    <li class="check-icon">
                        Complexo Adaptógeno (Ginseng)
                        Equilíbrio hormonal e suporte ao estresse
                    </li>
                    <li class="check-icon">
                        Extrato de Romã + Polifenóis de Uva
                    </li>
                    <li class="check-icon">
                        Curcumina com tecnologia NovaSol
                    </li>
                    <li class="check-icon">
                        Spermidina + Apigenina
                    </li>
                    <li class="check-icon">
                        Extrato de Chá Verde + EGCG
                    </li>
                    <li class="check-icon">Fisetina + Pterostilbeno
                    </li>
                  </ul>
  
                  <h4><img src=${upgradeIcon} alt="upgradeIcon" />UPGRADES:</h4>
                  <hr/>
                  <ul class="list-unstyled upgrades">
                    <li class="check-icon">Ativação celular para longevidade e regeneração</li>
                    <li class="check-icon">Otimização máxima para sistema nervoso, imunológico e cardiovascular</li>
                    <li class="check-icon">Suporte avançado para mitocôndrias e metabolismo energético</li>
                    <li class="check-icon">Antienvelhecimento e autofagia celular aprimorada</li>
                  </ul>
                </div>
              </div>`
    },
  ];


  return (
    <div id="ModalSliderKitDetails" className="ModalSliderKitDetails carousel slide" data-bs-ride="false">

      <div className="carousel-inner">
        {kits.map((kit, index) => (
          <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
            <div className="container-fluid">
              <div className="row justify-content-center text-center">
                <div className="col">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/${kit.image}`} alt={kit.label} className="img-fluid" />
                </div>
              </div>
              <div className="row justify-content-center text-center">
                <div className="col">
                  <h2 className="mt-4 mb-3 text-center">{kit.version}</h2>
                </div>
              </div>
              <div className="row justify-content-center text-center">
                <div className="col" style={{ maxWidth: "630px" }}>
                  <h3 className="mb-4 text-center">{kit.subtitle}</h3>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-auto mb-5">
                  <Button onClick={() => handleNavigate('/questionario/adulto')} label="Comprar" />
                </div>
              </div>
              <div className="row justify-content-between align-items-center mb-4 price-line">
                <hr />
                <div className="col-md-auto">
                  <p className="mb-0"><i className="bi bi-currency-dollar icon"></i> A PARTIR DE</p>
                  <h3 className="m-0">{new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(kit.price || 0)}/mês</h3>
                </div>
                <div className="col-md-auto">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-auto">
                      <img src={battery} alt="battery" className="battery" width="20" />
                    </div>
                    <div className="col">
                      <h4 className="m-0">NÍVEL DE SAÚDE E PERFORMANCE</h4>
                      <p className="m-0">{kit.level}</p>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <div className="row align-items-center">
                <div className="col">
                  <div dangerouslySetInnerHTML={{ __html: kit.details }} />
                </div>
              </div>
              <div className="row align-items-center subscribeBox my-4">
                <div className="col-md-auto">
                  <h3 className="m-0 text-white"><img src={percentIcon} alt="percentIcon" /> ASSINE COM <br />20% DE DESCONTO</h3>
                </div>

                <div className="col-md">
                  <p className="mb-1 text-decoration-line-through text-white">De {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(kit.price || 0)}</p>
                  <h3 className="m-0 text-white">{new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(kit.price * .8 || 0)}/mês</h3>
                </div>

                <div className="col-md-auto text-white text-end helpCol" style={{ backgroundColor: "rgba(255,255,255,.2)" }}>
                  <Link>Precisa de ajuda? <img src={helpWhiteIcon} alt="helpWhiteIcon" /></Link><br />
                  <Link>Download da fórmula <img src={downloadWhiteIcon} alt="downloadWhiteIcon" /></Link>
                </div>
              </div>
              <div className="row justify-content-center align-items-center">
                <div className="col-auto mt-4">
                  <Button onClick={() => handleNavigate('/questionario/adulto')} label="Iniciar anamnese" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="sliderButtons">
        <button className="carousel-control-prev" type="button" data-bs-target="#ModalSliderKitDetails" data-bs-slide="prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="55" height="56" viewBox="0 0 55 56" fill="none">
            <g filter="url(#filter0_d_2735_7530)">
              <circle cx="24.5" cy="25.5" r="17.5" fill="white" />
            </g>
            <path d="M24.2306 19.7108C23.8398 19.3186 23.2047 19.3186 22.8139 19.7108L22.7027 19.8224C22.3141 20.2123 22.3138 20.843 22.7019 21.2334L26.2435 24.7949C26.6314 25.1849 26.6314 25.8151 26.2435 26.2051L22.7019 29.7666C22.3138 30.157 22.3141 30.7877 22.7027 31.1776L22.8139 31.2892C23.2047 31.6814 23.8398 31.6814 24.2306 31.2892L29.2965 26.2059C29.6854 25.8156 29.6854 25.1844 29.2965 24.7941L24.2306 19.7108Z" fill="#846C51" />
            <g filter="url(#filter1_d_2735_7530)">
              <circle cx="24.5" cy="24.5" r="17.5" transform="rotate(-180 24.5 24.5)" fill="white" />
            </g>
            <path d="M24.7694 30.2892C25.1602 30.6814 25.7953 30.6814 26.1861 30.2892L26.2973 30.1776C26.6859 29.7877 26.6862 29.157 26.2981 28.7666L22.7565 25.2051C22.3686 24.8151 22.3686 24.1849 22.7565 23.7949L26.2981 20.2334C26.6862 19.843 26.6859 19.2123 26.2973 18.8224L26.1861 18.7108C25.7953 18.3186 25.1602 18.3186 24.7694 18.7108L19.7035 23.7941C19.3146 24.1844 19.3146 24.8156 19.7035 25.2059L24.7694 30.2892Z" fill="#846C51" />
            <defs>
              <filter id="filter0_d_2735_7530" x="0" y="1" width="55" height="55" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="3" dy="3" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.172549 0 0 0 0 0.0235294 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2735_7530" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2735_7530" result="shape" />
              </filter>
              <filter id="filter1_d_2735_7530" x="0" y="0" width="55" height="55" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="3" dy="3" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.172549 0 0 0 0 0.0235294 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2735_7530" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2735_7530" result="shape" />
              </filter>
            </defs>
          </svg>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#ModalSliderKitDetails" data-bs-slide="next">
          <svg xmlns="http://www.w3.org/2000/svg" width="55" height="56" viewBox="0 0 55 56" fill="none">
            <g filter="url(#filter0_d_2735_7566)">
              <circle cx="24.5" cy="24.5" r="17.5" transform="rotate(-180 24.5 24.5)" fill="white" />
            </g>
            <path d="M24.7694 30.2892C25.1602 30.6814 25.7953 30.6814 26.1861 30.2892L26.2973 30.1776C26.6859 29.7877 26.6862 29.157 26.2981 28.7666L22.7565 25.2051C22.3686 24.8151 22.3686 24.1849 22.7565 23.7949L26.2981 20.2334C26.6862 19.843 26.6859 19.2123 26.2973 18.8224L26.1861 18.7108C25.7953 18.3186 25.1602 18.3186 24.7694 18.7108L19.7035 23.7941C19.3146 24.1844 19.3146 24.8156 19.7035 25.2059L24.7694 30.2892Z" fill="#846C51" />
            <g filter="url(#filter1_d_2735_7566)">
              <circle cx="24.5" cy="25.5" r="17.5" fill="white" />
            </g>
            <path d="M24.2306 19.7108C23.8398 19.3186 23.2047 19.3186 22.8139 19.7108L22.7027 19.8224C22.3141 20.2123 22.3138 20.843 22.7019 21.2334L26.2435 24.7949C26.6314 25.1849 26.6314 25.8151 26.2435 26.2051L22.7019 29.7666C22.3138 30.157 22.3141 30.7877 22.7027 31.1776L22.8139 31.2892C23.2047 31.6814 23.8398 31.6814 24.2306 31.2892L29.2965 26.2059C29.6854 25.8156 29.6854 25.1844 29.2965 24.7941L24.2306 19.7108Z" fill="#846C51" />
            <defs>
              <filter id="filter0_d_2735_7566" x="0" y="0" width="55" height="55" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="3" dy="3" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.172549 0 0 0 0 0.0235294 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2735_7566" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2735_7566" result="shape" />
              </filter>
              <filter id="filter1_d_2735_7566" x="0" y="1" width="55" height="55" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="3" dy="3" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.172549 0 0 0 0 0.0235294 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2735_7566" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2735_7566" result="shape" />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ModalSliderKitDetails;